<script setup lang="ts">
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import {
    EditableStringField,
    InformationBaseCard,
    StackLayout,
    TypographyWithPrefix
} from '@rfc/rfc-components-library'

type Props = {
    data: Partial<CheckpointModel>
    editMode?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<CheckpointModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <InformationBaseCard :label="$t('checkpoint.title.informationsTitle')" class="w-full">
        <StackLayout direction="column" :gap="8" class="w-full max-w-md sm:max-w-full">
            <EditableStringField
                :label="$t('checkpoint.model.name')"
                :modelValue="data?.name"
                boldLabel
                :editMode="editMode"
                @change="$emit('change', { name: $event })"
                required />
            <TypographyWithPrefix :prefix="$t('checkpoint.model.id')" :label="data?.id" boldLabel />
            <EditableStringField
                :label="$t('checkpoint.model.comments')"
                :modelValue="data?.comments"
                @change="$emit('change', { comments: $event })"
                boldLabel
                :editMode="editMode" />
        </StackLayout>
    </InformationBaseCard>
</template>
